// mq stands for "media query"
import { getValueAndUnit } from 'polished';
import { breakpoints } from '../../css/breakpoints';

const getMaxWidth = (breakpoint: string) => {
  const breakpointBuffer = 0.0025;
  const [value, unit] = getValueAndUnit(breakpoint) as [number, string];
  return `@media (max-width: ${Math.max(value - breakpointBuffer, 0)}${unit})`;
};

const xsAndUp = () => `@media (min-width: ${breakpoints.xs})`;
const smAndUp = () => `@media (min-width: ${breakpoints.sm})`;
const mdAndUp = () => `@media (min-width: ${breakpoints.md})`;
const lgAndUp = () => `@media (min-width: ${breakpoints.lg})`;
const xlAndUp = () => `@media (min-width: ${breakpoints.xl})`;

const xsAndDown = () => getMaxWidth(breakpoints.xs);
const smAndDown = () => getMaxWidth(breakpoints.sm);
const mdAndDown = () => getMaxWidth(breakpoints.md);
const lgAndDown = () => getMaxWidth(breakpoints.lg);
const xlAndDown = () => getMaxWidth(breakpoints.xl);

export const mq = {
  xsAndUp,
  smAndUp,
  mdAndUp,
  lgAndUp,
  xlAndUp,
  xsAndDown,
  smAndDown,
  mdAndDown,
  lgAndDown,
  xlAndDown,
};
